import {useTranslation} from "ni18n";
import React from "react";
import {V5Img} from "src/components/_common/Carbon";

type Props = {
  src: string;
  alt: string;
  header: string;
  list: string[];
  backgroundColor: string;
  pattern: string;
  className?: string;
};

const ColorCard: React.FC<Props> = ({
  src,
  alt,
  header,
  backgroundColor,
  list,
  pattern,
  className,
}) => {
  const i18n = useTranslation();
  return (
    <div
      className={`pos-r ph8 pv8 pb20-xs br4 minh120 minh100-sm oh maxw28 maxw20-sm ${
        className || ""
      }`}
      style={{backgroundColor}}
    >
      <div className="pos-r zIndex1">
        <V5Img height={80} src={`${src}.jpg`} alt={alt} className="mb4" />
        <h4 className="mb4 font-csb fs24 fs20-sm maxw16 lh15">{header}</h4>
        <ul className="font-ir-sm fs14-sm fs18 lh15 ml7" style={{listStyle: "unset"}}>
          {list.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
      <V5Img
        src={`/paint-strokes/${pattern}.jpg`}
        className="pos-a bottom0 left0"
        alt={i18n.t("Illustrated pattern")}
      />
    </div>
  );
};

export default ColorCard;
